import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { EquivalenciaProductoService } from 'src/app/services/equivalencia-producto.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalAddEditProductoEquivalenciaComponent } from './modal-add-edit/modal-add-edit.component';
import IEquivalenciaProducto, { IEquivalenciaProductoExtended } from 'src/app/shared/object/equivalencia-producto.model';
import { ModalSeleccionarProveedorComponent } from '../../shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
import { debounceTime, filter } from 'rxjs/operators';
import { RutService } from 'src/app/shared/services/rut.service';

interface IHeaderForm {
  cliente_proveedor_rut: number
  includeInactive: boolean
}

@Component({
  selector: 'app-maestro-equivalencias',
  templateUrl: './maestro-equivalencias.component.html',
  styleUrls: ['./maestro-equivalencias.component.scss'],
  providers: [SecurityService]
})
export class MaestroEquivalenciasComponent implements OnInit {

  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent
  @ViewChild(ModalAddEditProductoEquivalenciaComponent, { static: true }) addEditModal: ModalAddEditProductoEquivalenciaComponent
  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>()

  // Form
  formHeader: FormGroup;
  initialValues: IHeaderForm

  // Data & Tmp
  rutEmpresa: number
  sucursalCodigo: number
  optionsProveedor: Array<any> = [];
  loading: boolean = false
  registros: Array<IEquivalenciaProductoExtended> = null;
  paginationContext: PaginationContext = new PaginationContext()
  proveedorSeleccionado: any = null
  headerData: any = {}

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private rutService: RutService,
    private equivalenciaProductoService: EquivalenciaProductoService
  ) {
    this.log = this.clog.log('MAESTRO-EQUIVALENCIAS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10

    //this.loadProveedores()

    this.createFormInitialValues()
    this.createForms()
    this.formChangesSubscriptions()
  }

  createFormInitialValues() {
    this.initialValues = {
      cliente_proveedor_rut: null,
      includeInactive: false
    }
  }

  private createForms() {
    this.formHeader = this.fb.group({
      cliente_proveedor_rut: [null, [Validators.required]],
      sku: [null],
      descripcion: [null],
      includeInactive: [null, [Validators.required]],
    });

    this.setInitialValues()
  }

  private formChangesSubscriptions() {
    this.formHeader.get("cliente_proveedor_rut").valueChanges
      .pipe(filter(Boolean), debounceTime(2500))
      .subscribe((cliente_proveedor_rut: string) => {
        this.modalSeleccionarProveedor.searchByRut(cliente_proveedor_rut)
      })
  }

  abrirModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show()
  }

  onProveedorSeleccionado({ data, origen }) {
    this.proveedorSeleccionado = data
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut)
    this.formHeader.get('cliente_proveedor_rut').setValue(this.proveedorSeleccionado.rutFormato)
    this.onProveedorChange.emit(this.headerData.proveedorSeleccionado)
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null
    this.clearProveeData()
  }
  clearProveeData() {
    this.clearContent()
    this.onProveedorChange.emit(null)
  }

  clearContent() {
    this.headerData = {}
    this.formValidatorsService.reset(this.formHeader)
  }

  private setInitialValues() {
    this.formValidatorsService.setInitialState(this.formHeader, this.initialValues)
    this.formHeader.markAsPristine()
    this.formHeader.markAsUntouched()
  }

  buscar(pageNumber: number = 1) {
    this.formValidatorsService.validateAllFormFields(this.formHeader)
    if (!this.formHeader.valid)
      return

    this.registros = []
    this.loading = true

    this.paginationContext.CurrentPage = pageNumber

    const { includeInactive, sku, descripcion } = this.formHeader.value

    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        cliente_proveedor_rut: this.proveedorSeleccionado.rut,
        producto_proveedor: sku,
        detalle_producto: descripcion,
        includeInactive,
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.equivalenciaProductoService.obtenerSegunProveedor(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.registros = registros
      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  showAddEquivalencia() {
    this.addEditModal.show()
  }

  loadEquivalencia(equivalencia_producto: IEquivalenciaProducto) {
    this.addEditModal.loadAndshow(equivalencia_producto.id)
  }

  eliminarEquivalencia(equivalencia_producto: IEquivalenciaProducto) {
    const inputParams = {
      entidad: {
        id: equivalencia_producto.id,
        empresa_rut: equivalencia_producto.empresa_rut,
        sucursal_codigo: equivalencia_producto.sucursal_codigo,
        cliente_proveedor_rut: equivalencia_producto.cliente_proveedor_rut,
        producto_proveedor: equivalencia_producto.producto_proveedor,
        detalle_producto: equivalencia_producto.detalle_producto,
        formato_codigo: equivalencia_producto.formato_codigo,
        factor_equivalencia: equivalencia_producto.factor_equivalencia,
        producto_codigo: equivalencia_producto.producto_codigo,
        formato_codigo_top: equivalencia_producto.formato_codigo_top,
        activado: equivalencia_producto.activado,
        observacion: equivalencia_producto.observacion
      },
    }
    const confirmacion = window.confirm(
      'Esta seguro de eliminar Equivalencia'
    );
    if (confirmacion) {
      this.equivalenciaProductoService.eliminarEquivalencia(inputParams, ({ mensajes, respuesta }) => {
        // Verificar si hay mensajes de error
        const hasErrors = mensajes && mensajes.some(m => m.tipo === 'ERROR')

        if (hasErrors) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        // Si no hay errores, mostrar mensajes de éxito si existen
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showInfoMessages(mensajes)
        }

        this.toastService.success('Equivalencia eliminada exitosamente')
        this.buscar(1)
      })
    }
  }

  limpiarData() {
    this.registros = []
    this.formHeader.reset()
    this.formHeader.get("sku").setValue('')
    this.formHeader.get("descripcion").setValue('')
    this.formHeader.get("includeInactive").setValue(false)
    this.proveedorSeleccionado = null
  }

}
